/**
 * Isapres que se pueden elegir en la ficha — fuente única del frontend.
 *
 * Debe coincidir con `ISAPRE_NAMES` en `backend/apps/payroll/models.py`: la
 * clave es lo que se guarda, y la traducen a sus códigos Previred
 * (`ISAPRE_CODE_MAP`) y el LRE (`LRE_HEALTH_CODES`).
 *
 * Antes el nombre se escribía a mano: «nueva mas vida» no correspondía a
 * ninguna isapre y Previred declaró la cotización sin institución (zenlatam,
 * septiembre de 2026).
 */
export const ISAPRE_NAMES: Record<string, string> = {
  banmedica: 'Banmédica',
  colmena: 'Colmena',
  consalud: 'Consalud',
  cruz_blanca: 'Cruz Blanca',
  cruz_del_norte: 'Cruz del Norte',
  esencial: 'Esencial',
  fundacion: 'Fundación (Banco Estado)',
  isalud: 'Isalud',
  nueva_masvida: 'Nueva Masvida',
  vida_tres: 'Vida Tres',
}

export const ISAPRE_OPTIONS = Object.entries(ISAPRE_NAMES).map(([value, label]) => ({ value, label }))
